var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "borderless-select" },
    [
      _c("HKLSelect", {
        staticClass: "hkl-select--borderless",
        attrs: {
          value: _vm.selectValue,
          options: _vm.formattedOptions,
          showSearch: false,
          placeholder: "",
        },
        on: { change: _vm.updateValue },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }